import axios from "axios";
import { setDefaultSessionTokenHeader } from "../../componentes-padrao/AxiosConfig";
import { scheduleAccessTokenRefresh } from "../../utils/jwt";
import { configureSession } from "../../utils/session";

export const api = axios.create({
    baseURL: process.env.API_URL,
});

export const handleResponse = (response) => {
    const newAccessToken: string = response.data
        ? response.data["access_token"]
        : null;
    const newRefreshToken: string = response.data
        ? response.data["refresh_token"]
        : null;

    if (newAccessToken) {
        configureSession(newAccessToken, newRefreshToken);

        setDefaultSessionTokenHeader(newAccessToken, newRefreshToken);

        scheduleAccessTokenRefresh(newAccessToken, newRefreshToken);
    }

    return response;
};

api.interceptors.response.use(handleResponse, async (error) => {
    if (error.response) {
        if (error.response.status === 401) {
            window.location.reload();
        }
    }
    return Promise.reject(error);
});

export const api_go = axios.create({
    baseURL: process.env.API_GO_URL,
});

api_go.interceptors.response.use(handleResponse, async (error) => {
    if (error.response) {
        if (error.response.status === 401) {
            window.location.reload();
        }
    }
    return Promise.reject(error);
});

export const api_v1_go = axios.create({
    baseURL: process.env.API_V1_GO_URL,
});

api_v1_go.interceptors.response.use(handleResponse, async (error) => {
    if (error.response) {
        if (error.response.status === 401) {
            window.location.reload();
        }
    }
    return Promise.reject(error);
});

export const api_reports_go = axios.create({
    baseURL: process.env.API_REPORTS_GO_URL,
});

api_reports_go.interceptors.response.use(handleResponse, async (error) => {
    if (error.response) {
        if (error.response.status === 401) {
            window.location.reload();
        }
    }
    return Promise.reject(error);
});

export const oldApi = axios.create({
    baseURL: process.env.OLD_API_URL,
});

export const reportsApi = axios.create({
    baseURL: process.env.API_REPORTS_URL,
});

export const analyticsApi = axios.create({
    baseURL: process.env.API_LOGAE_ANALYTICS_URL,
});

/** API de integração do e360: recebe os registros de uso das telas. */
export const e360Api = axios.create({
    baseURL: process.env.API_E360_INTEGRACAO_URL,
});
